export function userSilhuette() {
    const site = window.Stash.common.site;
    return ['jobdk', 'stedk', 'itjdk'].includes(site) ? `/img/jobindex20/user_silhuette_${site}.svg` : `/img/jobindex20/user_silhuette.svg`;
}
